<template>
	<!-- 场景编辑 -->
	<div class="sceneSettingEdit_main"  :class="{'cn':version == '1','ja':version == '2'}">
		<div class="cont_box">
			<div class="form_box">
				<div class="form_item">
					<div class="text label">{{ $t('App.sceneSetting.label1') }}</div>
					<div class="form_item_content">
						<el-input class="input1" v-model="sceneForm.name"
							:placeholder="$t('App.sceneSetting.placeholder1')"></el-input>
					</div>
				</div>
				<template v-for="(obj, index) in sceneForm.subSceneList">
					<div class="flex_box" :key="'scene' + index" v-if="index >= scenePaging * 1 && index < scenePaging * 1 + 1">
						<div class="form_item" style="margin-top: 2rem;">
							<div class="text label"><span class="i">*</span>{{ $t('App.sceneSetting.label2') }}</div>
							<!-- 分组 -->
							<div class="form_item_content" style="display: flex;">
								<div class="label">{{ $t('App.sideBar.text23') }}</div>
								<div class="select_lm multiple" :class="groupSelectShowArr[index] ? 'select' : ''">
									<div class="val_box" @click="groupSelectFun(index)">
										<div class="val" :title="obj.groupNames">{{ obj.groupNames }}</div>
										<div class="icon_x"></div>
									</div>
									<div class="select_xl_lm_bg" v-if="groupSelectShowArr[index]"
										@click="groupSelectFun(index)"></div>
									<div class="select_xl_lm" v-if="groupSelectShowArr[index]">
										<div class="icon"></div>
										<div class="ul scrollbar_style">
											<template  v-for="(item, index) in groupList">
												<div :key="index" class="li" @click="groupItemClick(obj, item)" v-if="groupIdsArrAll.indexOf(item.id + '') == -1 || obj.groupIdsArr.indexOf(item.id + '') != -1">
													<div class="text">{{ item.name }}</div>
													<div class="selectDrop" :class="obj.groupIdsArr.indexOf(item.id + '') != -1 ? 'select' : ''">
														<div class="drop"></div>
													</div>
												</div>
											</template>
											
										</div>
									</div>
								</div>
							</div>
							<!-- 灯控 -->
							<div class="form_item_content" style="display: flex;">
								<div class="label">{{ $t('App.sideBar.text24') }}</div>
								<div class="select_lm multiple" :class="deviceSelectShowArr[index] ? 'select' : ''">
									<div class="val_box" @click="deviceSelectFun(index)">
										<div class="val" :title="obj.lampNames">{{ obj.lampNames }}</div>
										<div class="icon_x"></div>
									</div>
									<div class="select_xl_lm_bg" v-if="deviceSelectShowArr[index]"
										@click="deviceSelectFun(index)"></div>
									<div class="select_xl_lm" v-if="deviceSelectShowArr[index]">
										<div class="icon"></div>
										<div class="ul scrollbar_style">
											<template  v-for="(item, index) in deviceList">
												<div class="li" @click="deviceItemClick(obj, item)" :key="index" v-if="lampIdArrAll.indexOf(item.id + '') == -1 || obj.lampIdArr.indexOf(item.id + '') != -1">
													<div class="text">{{ item.name }}</div>
													<div class="selectDrop"
														:class="obj.lampIdArr.indexOf(item.id + '') != -1 ? 'select' : ''">
														<div class="drop"></div>
													</div>
												</div>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="form_item margin" style="margin-top: 6.6rem;">
							<!-- <div class="text label"><span class="i">*</span>{{ $t('App.sceneSetting.label3') }}</div> -->
							<div class="label" style="width: 20rem;">
								<div class="select_lm" :class="sceneTypeSelectShowArr[index] ? 'select' : ''">
									<div class="val_box" @click="sceneTypeSelectFun(index)">
										<span class="i">*</span>
										<div class="val" :title="obj.typeName">{{ obj.typeName }}</div>
										<div class="icon_x"></div>
									</div>
									<div class="select_xl_lm_bg" v-if="sceneTypeSelectShowArr[index]"
										@click="sceneTypeSelectFun(index)"></div>
									<div class="select_xl_lm" v-if="sceneTypeSelectShowArr[index]">
										<div class="icon"></div>
										<div class="ul scrollbar_style">
											<!-- user-select: none; -->
											<div class="li" :class="obj.type == item.id ? 'select' : ''" v-for="(item, idx) in sceneTypeArr" :key="idx"
												@click="sceneTypeItemClick(item, index,obj)">
												<div class="text">{{ item.name }}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!--  -->
							<div class="form_item_content" style="margin-top: 4rem;">
								<div class="slider_box" v-if="obj.type == 1">
									<el-slider v-model="obj.value" :format-tooltip="valueTooltip" :show-tooltip="true"></el-slider>
									<div class="slider_b">
										<div class="text span1">0%</div>
										<div class="text span2">100%</div>
									</div>
									
								</div>
								<div class="slider_box color" v-if="obj.type == 7">
									<el-slider v-model="obj.color" :style="colorStyle(obj)" :min="2700" :max="6500" :show-tooltip="true"></el-slider>
									<div class="slider_b">
										<div class="text span1">2700</div>
										<div class="text span2">6500</div>
									</div>
								</div>
								<div class="marquee_box" style="display: flex;" v-if="obj.type == 2">
									<div class="label" style="margin-bottom: 0;padding-left: 0;"><span class="i">*</span>{{ $t('App.sceneSetting.sort') }}</div>
									<div class="select_lm" :class="orderTypeSelectShowArr[index] ? 'select' : ''">
										<div class="val_box" @click="orderSelectFun(index)">
											
											
											<div class="val" :title="obj.orderName">{{ obj.orderName }}</div>
											<div class="icon_x"></div>
											
											<div class="icon_x"></div>
										</div>
										<template v-if="!isMobile">

											<div class="select_xl_lm_bg" v-if="orderTypeSelectShowArr[index]" @click="orderSelectFun(index)" @mouseup="orderMouseup(obj)" @mousemove="orderMousemove($event)"></div>
											<div class="select_xl_lm drag" v-if="orderTypeSelectShowArr[index]" @mouseup="orderMouseup(obj)" @mousemove="orderMousemove($event)">
												<div class="icon"></div>
												<div class="ul scrollbar_style" :class="'order_ul_'+index" @scroll="orderScroll($event)">
													<template v-for="(item, idx) in obj.orderList">
														<div class="li_box" :key="idx">
															<div class="li" v-if="orderTypeDownObj.idx>idx&&(orderTypeDownObj.moveIndex==idx&&orderTypeDownObj.drag)"></div>
															<div class="li" :class="'li'+idx"  @mousedown ="orderMousedown($event,obj,index,item,idx)" v-if="orderTypeDownObj.id!=item.id">
																<div class="text">{{ item.name }}</div>
																<div class="text" v-if="!orderTypeDownObj.drag">{{ idx+1 }}</div>
															</div>
															<div class="li" v-if="orderTypeDownObj.idx<=idx&&(orderTypeDownObj.moveIndex==idx&&orderTypeDownObj.drag)"></div>
														</div>
													</template>
													<div class="li select" v-if="orderTypeDownObj.drag" :style="{top:orderTypeDownObj.top+'px'}">
														<div class="text">{{ orderTypeDownObj.name }}</div>
													</div>
												</div>
											</div>
										</template>


										<!-- 平板 -->
										<template v-if="isMobile">
											<div class="select_xl_lm_bg" v-if="orderTypeSelectShowArr[index]" @click="orderSelectFun(index)"  @touchend="orderMouseup(obj)"  @touchmove="orderMousemove($event)"></div>
											<div class="select_xl_lm drag" v-if="orderTypeSelectShowArr[index]" @touchend="orderMouseup(obj)" @touchmove="orderMousemove($event)">
												<div class="icon"></div>

												<!-- <div>{{ isMobile }}</div>
												<div>{{ orderTypeDownObj.top }}</div> -->
												<div class="ul scrollbar_style" :class="'order_ul_'+index" @scroll="orderScroll($event)">
													<template v-for="(item, idx) in obj.orderList">
														<div class="li_box" :key="idx">
															<div class="li" v-show="orderTypeDownObj.idx>idx&&(orderTypeDownObj.moveIndex==idx&&orderTypeDownObj.drag)"></div>
															<div class="li" :class="'li'+idx" @touchstart="orderMousedown($event,obj,index,item,idx)" v-show="orderTypeDownObj.id!=item.id">
																<div class="text">{{ item.name }}</div>
																<div class="text" v-show="!orderTypeDownObj.drag">{{ idx+1 }}</div>
															</div>
															<div class="li" v-show="orderTypeDownObj.idx<=idx&&(orderTypeDownObj.moveIndex==idx&&orderTypeDownObj.drag)"></div>
														</div>
													</template>
													<div class="li select" v-show="orderTypeDownObj.drag" :style="{top:orderTypeDownObj.top+'px'}">
														<div class="text">{{ orderTypeDownObj.name }}</div>
													</div>
												</div>
											</div>
										</template>

									</div>
								</div>

							</div>
							<div class="form_item_content" style="display: flex;margin-top: 2rem;" v-if="obj.type == 2 ">
								<div class="label" style="margin-bottom: 0;padding-left: 0;"><span class="i">*</span>{{ $t('App.sceneSetting.duration') }}</div>
								<!-- <el-input class="input1" v-model="obj.duration" placeholder=""></el-input> -->
								<el-input-number v-model="obj.duration" :min="0" :controls="false"></el-input-number>
							</div>
						</div>
						
						<div class="del">
							<div class="delBtn" style="margin-left: 10rem;margin-top: 6.6rem;"
								@click="subSceneDel(index,obj)">{{ $t('App.delete') }}</div>
						</div>
					</div>
				</template>
			</div>
			<div class="icon btn addBtn" @click="subSceneAdd()"></div>
		</div>
		<div class="foot_box">
			<div class="paging_box" v-if="sceneTotal + 1 > 0">
				<div class="icon btn icon1" @click="pagingFun(-1)"></div>
				<div class="paging">{{ scenePaging + 1 }}/{{ sceneTotal + 1 }}</div>
				<div class="icon btn icon2" @click="pagingFun(1)"></div>
			</div>
			<div class="btn1" @click="pageTypeFun('sceneSetting')">{{ $t('App.cancel') }}</div>
			<div class="btn2" v-loading="loading.sceneAdd" @click="saveSceneFun('sceneSetting')">{{ $t('App.ok') }}</div>
		</div>

		<!-- 选择页面 -->
		<el-dialog :show-close="false" :visible.sync="selectVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="36.51rem" class="selection" >
			<el-radio-group style="display: grid;" v-model="getUserSettingInfoDateValue_">
				<el-radio :disabled="getUserSettingInfoDate.sysStatus === 1" label="systemSetting">{{$t('App.status.text0')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.projectStatus === 1" label="projectSettings">{{$t('App.status.text1')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.gatewayStatus === 1" label="gatewayInput">{{$t('App.projectSettings.text5')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.deviceStatus === 1" label="controllerInput">{{$t('App.status.text2')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.groupStatus === 1" label="groupSetting">{{$t('App.status.text3')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.sceneStatus === 1" label="sceneSettingEdit">{{$t('App.status.text4')}}</el-radio>
				<el-radio :disabled="getUserSettingInfoDate.scheduleStatus === 1" label="schedule">{{$t('App.status.text5')}}</el-radio>
			</el-radio-group>
			<span  slot="footer" class="footer">
				<el-button @click="projectSelection()">Enter</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex'
import allUrl from '../api/allUrl.js'
import base from '../api/base.js'
export default {
	name: 'projectSettings',
	data() {
		return {
			scenePaging: 0,
			sceneTotal: 1,
			// groupNames:'',
			groupIds: '',

			groupNavList: [],
			
			sceneForm: {
				name: '',
				subSceneList: [
					{
						groupNames: '',
						groupIds: '',
						deviceIds: '',
						deviceNames: '',

						type: '',
						typeName: '',
						value: 0,
						color: 0,
						groupDevIds: '',
						groupDevName: '',

						orderList:{
							id: '',
							name: '',
						}
					}
				],
			},

			groupIdsArrAll: [],
			lampIdArrAll: [],

			groupSelectShow: false,
			groupSelectShowArr: [],

			deviceSelectShowArr: [],

			orderTypeSelectShowArr: [],
			orderTypeArr: [],
			orderTypeDownObj: {
				id:'',
				index:0,
				idx:0,
				moveIndex:0,
				drag:false,
				name:'',
				top:0,
				height: 0,
				scrollTop:0,
			},

			sceneTypeSelectShow: false,
			sceneTypeSelectShowArr: [],
			sceneTypeArr: [],
			sceneTypeName: '',
			sceneTypeId: '',

			// typeName: '',
			// typeId: '',
			groupList: [],
			deviceList: [],

			selectVisible: false,
			getUserSettingInfoDateValue_:'systemSetting',
			getUserSettingInfoDate :{
				sysStatus:'',
				projectStatus:'',
				gatewayStatus:'',
				deviceStatus:'',
				groupStatus:'',
				sceneStatus:'',
				scheduleStatus:'',
			},

			loading: {
				sceneAdd: false,
			}
		}
	},
	computed: {
		...mapGetters({
			token: 'token',
			client_key: 'client_key',
			username: 'username',
			version: 'version',

			projectId: 'projectId',
			projectName: 'projectName',

			sceneType: 'sceneType',
			sceneId: 'sceneId',

			remRatio: 'remRatio',
			updateRemRatio: 'updateRemRatio',

			projectUpdate: 'projectUpdate',

			countryId: 'countryId',
			provinceId: 'provinceId',
			cityId: 'cityId',
			hotelId: 'hotelId',
			headerIdStr: 'headerIdStr',

			isMobile:'isMobile',
			themeType: 'themeType',
		}),
		// sensorFormModelName(){
		//     let name = '';
		//     for(let d of this.modelNav){
		//         if(d.id == this.sensorForm.model){
		//             name = d.name
		//         }
		//     }
		//     return name
		// }
	},
	components: {
		// 'sideBar':sideBar
	},
	beforeDestroy() {
	},
	mounted() {
		this.getUserSettingInfo();
		
		this.sceneTypeArr = [
			{ id: 1, name: this.$t('App.sceneSetting.sceneType1') },
			{ id: 2, name: this.$t('App.sceneSetting.sceneType2') },
			{ id: 3, name: this.$t('App.sceneSetting.sceneType3') },
			{ id: 7, name: this.$t('App.sceneSetting.sceneType7') },
			// { id: 4, name: this.$t('App.sceneSetting.sceneType4') },
			// { id: 5, name: this.$t('App.sceneSetting.sceneType5') },
		]

		if (this.sceneType == 'edit') {
			this.sceneDetailsGet()
		} else {
			this.$set(this.sceneForm.subSceneList[0], 'type', this.sceneTypeArr[0].id)
			this.$set(this.sceneForm.subSceneList[0], 'typeName', this.sceneTypeArr[0].name)
			
			this.scenePaging = 0;
			this.sceneTotal = 0;

			this.lampIdArrAll = [];
			this.groupIdsArrAll = [];
			this.groupNavGet(obj => {
				for (let dd of obj.data) {
					dd.select = 0;
					if (dd.type == 1) {
						this.groupList.push(dd)
					} else {
						this.deviceList.push(dd)
					}
				}
				for (let d of this.sceneForm.subSceneList) {
					this.$set(d, 'lampNames', '');
					this.$set(d, 'lampIdArr', d.deviceIds?d.deviceIds.split(',') : []);
					this.lampIdArrAll = this.lampIdArrAll.concat(d.groupIdsArr)
					
					for (let id of d.deviceIds.split(',')) {
						for (let dd of obj.data) {
							dd.select = 0;
							if (dd.type != 1) {
								if (dd.id == id) {
									if (d.lampNames == '') {
										d.lampNames = dd.name
									} else {
										d.lampNames += ',' + dd.name;
									}
								}
							}
						}
					}
					this.$set(d, 'groupNames', '');
					this.$set(d, 'groupIdsArr', d.groupIds ? d.groupIds.split(',') : []);
					this.groupIdsArrAll = this.groupIdsArrAll.concat(d.groupIdsArr)
					for (let id of d.groupIds.split(',')) {
						for (let dd of obj.data) {
							dd.select = 0;
							if (dd.type == 1) {
								if (dd.id == id) {
									if (d.groupNames == '') {
										d.groupNames = dd.name
									} else {
										d.groupNames += ',' + dd.name;
									}
								}
							}
						}
					}
					// console.log(d, this.sceneTypeArr, '---')

					for (let dd of this.sceneTypeArr) {
						if (d.type == dd.id) {
							d.typeName = dd.name
							d.type = dd.id
						}
					}
				}
			});
		}
		
	},
	methods: {
		skinClassFun(){
		let obj = {};
		obj['cn'] = this.version == '1';
		// obj['ratio_1920_1080'] = this.ratio == '1';
		if(this.themeType == 1){
			obj['themeType_' + 1] = true;
		}
		// obj['themeType_' + 1] = true;
		return obj
		},
		confirmSelection() {
			this.getUserSettingInfo(data => {
				if (data.isTrue) {
					this.selectVisible = true;
				}
			});
		},
		projectSelection(){
			this.$emit('pageTypeFun', this.getUserSettingInfoDateValue_)
			this.selectVisible = false;
		},
		delSchedule(item, index) {
			this.$confirm(
				this.$t('App.message.text3'), this.$t('App.message.text4'), {
				confirmButtonText: this.$t('App.message.text5'),
				cancelButtonText: this.$t('App.message.text6'),
				type: 'warning'
			}
			).then(() => {
				console.log(item.id)
				base.ajax_post(
					allUrl.schedule.schedule_del,
					{
						username: this.username,
						clientType: this.os,
						token: this.token,
						id: item.id
					},
					{},
					data => {
						this.$message({
							showClose: true,
							message: data.msg,
							type: 'success'
						});
						// this.sceneListGet();
						this.scheduleDetailsList.splice(index, 1);
						this.setCalendarList(this.calendarDateHc)
					},
					this)
			}).catch(() => {
				this.$message({
					type: 'info',
					message: this.$t('App.message.text7')
				})
			});
		},
		deviceItemClick(obj, item) {
			// console.log(item, '---4-4-44-')
			let id = item.id + '';
			let sceneName = obj.lampNames ? obj.lampNames.split(',') : [];
			let sceneId = obj.lampIdArr;
			for (let val of sceneId) {
				for (let key in this.lampIdArrAll) {
					if (this.lampIdArrAll[key] == val) {
						this.lampIdArrAll.splice(key, 1)
						break
					}
				}
			}
			if (sceneId.indexOf(id) == -1) {
				if (sceneId.length == 0) {
					sceneName = [item.name]
					sceneId = [id];
				} else {
					sceneName.push(item.name);
					sceneId.push(id);
				}
			} else {
				console.log(sceneName.length, '---s-s-')
				if (sceneId.length == 0) {
					sceneName = [item.name]
					sceneId = [id];
				} else {
					sceneName.splice(sceneId.indexOf(id), 1);
					sceneId.splice(sceneId.indexOf(id), 1);
				}
			}
			
			this.$set(obj, 'lampIdArr', sceneId)
			this.$set(obj, 'lampNames', sceneName.join(','))

			this.lampIdArrAll = this.lampIdArrAll.concat(obj.lampIdArr);

			this.orderInit(obj,'lamp')
			// this.lampId = data.id
		},
		groupItemClick(obj, item) {

			let id = item.id + '';
			let groupNames = obj.groupNames ? obj.groupNames.split(',') : [];
			let groupIds = obj.groupIdsArr;
			for (let val of groupIds) {
				for (let key in this.groupIdsArrAll) {
					if (this.groupIdsArrAll[key] == val) {
						this.groupIdsArrAll.splice(key, 1)
						break
					}
				}
			}
			// console.log(groupIds.indexOf(id)==-1,groupIds,'--sd-sd-sd-s-d-sd--')
			if (groupIds.indexOf(id) == -1) {
				if (groupIds.length == 0) {
					groupNames = [item.name];
					groupIds = [id];
				} else {
					groupNames.push(item.name);
					groupIds.push(id);
				}
			} else {
				if (groupIds.length == 0) {
					groupNames = [item.name];
					groupIds = [id];
				} else {
					groupNames.splice(groupIds.indexOf(id), 1);
					groupIds.splice(groupIds.indexOf(id), 1);
				}
			}
			// for(let d of this.groupNavList){
			//   if(d.select == 1){
			//   }
			// }
			// console.log(groupNames,groupIds,'---arr----')
			this.$set(obj, 'groupNames', groupNames.join(','))
			this.$set(obj, 'groupIdsArr', groupIds)

			this.groupIdsArrAll = this.groupIdsArrAll.concat(obj.groupIdsArr)
			this.orderInit(obj,'group')
		},
		//获取用户设置状态信息
		getUserSettingInfo(callback) {
			// this.selectVisible = true;
			base.ajax_post(
				allUrl.user.user_getUserSettingInfo,
				{
					username: this.username,
					version: this.version,
					token:this.token,
				},
				{},
				data => {
					this.getUserSettingInfoDate = data.data;
					data.isTrue = false;
					if(this.getUserSettingInfoDate.sysStatus == 0){
						this.getUserSettingInfoDateValue_ = 'systemSetting'
						data.isTrue = true
					} else if(this.getUserSettingInfoDate.projectStatus == 0){
						this.getUserSettingInfoDateValue_ = 'projectSettings'
						data.isTrue = true
					}else if(this.getUserSettingInfoDate.gatewayStatus == 0){
						this.getUserSettingInfoDateValue_ = 'gatewayInput'
						data.isTrue = true
					} else if(this.getUserSettingInfoDate.deviceStatus == 0){
						this.getUserSettingInfoDateValue_ = 'controllerInput'
						data.isTrue = true
					} else if(this.getUserSettingInfoDate.groupStatus == 0){
						this.getUserSettingInfoDateValue_ = 'groupSetting'
						data.isTrue = true
					} else if(this.getUserSettingInfoDate.sceneStatus == 0){
						this.getUserSettingInfoDateValue_ = 'sceneSettingEdit'
						data.isTrue = true
					}else if(this.getUserSettingInfoDate.scheduleStatus == 0){
						this.getUserSettingInfoDateValue_ = 'schedule'
						data.isTrue = true
					}
					if(callback){
						callback(data)
					}
				},
				this
			)
		},
		pagingFun(val) {
			this.scenePaging += val;
			if (this.scenePaging < 0) {
				this.scenePaging = 0
			}
			if (this.scenePaging > this.sceneTotal) {
				this.scenePaging = this.sceneTotal
			}
			this.subSceneList = this.sceneForm.subSceneList.slice(this.scenePaging * 1, this.scenePaging * 1 + 1);
		},
		valueTooltip(val) {
			return val + '%';
		},
		pageTypeFun(val) {
			this.$emit('pageTypeFun', val)
		},
		sceneTypeSelectFun(index) {
			if (this.sceneTypeSelectShowArr[index]) {
				this.$set(this.sceneTypeSelectShowArr, index, false)
			} else {
				this.$set(this.sceneTypeSelectShowArr, index, true)
			}
		},
		sceneTypeItemClick(data, index,obj) {
			obj.typeName = data.name;
			obj.type = data.id;
			
			console.log(obj.type,'---')
			if(obj.type == 2){
				this.orderInit(obj)
			}
			this.sceneTypeSelectFun(index);
		},
		orderInit(obj){
			let lampList = [];
			let orderNameArr = [];
			this.$set(obj,'orderList',[]);
			this.$set(obj,'orderName','');
			
			if(obj.lampIdArr.length>0){
				for(let key in obj.lampIdArr){
					lampList.push({id:obj.lampIdArr[key],name:obj.lampNames.split(',')[key]})
					orderNameArr.push(obj.lampNames.split(',')[key])
					obj.orderList.push({name:obj.lampNames.split(',')[key],id:obj.lampIdArr[key]})
				}
			}
			console.log(obj.lampIdArr.length>0,obj.orderList,orderNameArr,'----1----')
			if(obj.groupIdsArr.length>0){
				// this.$set(obj,'orderList',[]);
				// orderNameArr = [];
				let groupIds = obj.groupIdsArr.join(',')
				this.groupListGet(groupIds,data=>{
					// console.log(data)
					// let lampIdArr = [];
					for(let key in data.data){
						for(let d of data.data[key].lampList){
							// console.log(lampIdArr.indexOf(d.id+''),lampIdArr,d.id+'',lampList)
							console.log(obj.lampIdArr,d.id,'--wweweww---')
							if(obj.lampIdArr.indexOf(d.id+'') == -1){
								// lampList.push({id:d.id+'',name:d.name})
								// lampIdArr.push(d.id+'')
								orderNameArr.push(d.name)
								obj.orderList.push({name:d.name,id:d.id})
							}
						}
					}
					
					this.$set(obj,'orderName',orderNameArr.join(','))
				});
			}else{
				this.$set(obj,'orderName',orderNameArr.join(','))
			}
			console.log(obj.orderList,orderNameArr,'----2----')

		},
		//批量获取分组列表
		groupListGet(id,callback) {
			// console.log('---')

			base.ajax_post(
				allUrl.group.group_groupDetailsList,
				{
					username: this.username,
					version: this.version,
					token:this.token,
					ids:id
				},
				{},
				data => {
					callback(data)
				},
				this
			)
		},
		groupSelectFun(index) {
			if (this.groupList.length > 0) {
				if (this.groupSelectShowArr[index]) {
					this.$set(this.groupSelectShowArr, index, false)
				} else {
					this.$set(this.groupSelectShowArr, index, true)
				}
			}
		},
		orderSelectFun(index) {
			if (this.orderTypeSelectShowArr[index]) {
				this.$set(this.orderTypeSelectShowArr, index, false)
				this.$set(this.orderTypeDownObj, 'drag', false)
			} else {
				this.$set(this.orderTypeSelectShowArr, index, true)
				this.$set(this.orderTypeDownObj, 'drag', false)
				this.$set(this.orderTypeDownObj, 'id', '');
				this.$set(this.orderTypeDownObj, 'index', 0);
				this.$set(this.orderTypeDownObj, 'name', '');
				this.$set(this.orderTypeDownObj, 'top', 0);
				this.$set(this.orderTypeDownObj, 'moveIndex', 0);
				this.$set(this.orderTypeDownObj, 'idx', 0);
				this.$set(this.orderTypeDownObj, 'scrollTop', 0);
				this.$nextTick(() => {
					console.log($('.order_ul_'+index).height())
					this.$set(this.orderTypeDownObj, 'clientY', $('.order_ul_'+index).offset().top)
					this.$set(this.orderTypeDownObj, 'height', $('.order_ul_'+index).height())
				})
			}
		},
		orderMousemove(event){
			console.log('move',this.isMobile,this.orderTypeDownObj.moveIndex,this.orderTypeDownObj.index,this.orderTypeDownObj.drag)

			if(this.orderTypeDownObj.drag){
				if(this.isMobile){
					event.preventDefault();
					event = event.touches[0];
					// console.log(obj,index,this.orderTypeDownObj.clientY+this.orderTypeDownObj.height)
					let top = event.clientY - this.orderTypeDownObj.clientY - (2.5 * this.remRatio)/2 + this.orderTypeDownObj.scrollTop;
					if(top > this.orderTypeDownObj.height - 2.5 * this.remRatio  + this.orderTypeDownObj.scrollTop){
						top = this.orderTypeDownObj.height - 2.5 * this.remRatio + this.orderTypeDownObj.scrollTop
					}
					if(top < 0){
						top = 0;
					}
					this.orderTypeDownObj.moveIndex = Math.floor(top/(2.5 * this.remRatio)+0.5)
					// console.log(top,2.5 * this.remRatio,Math.floor(top/(2.5 * this.remRatio)))

					this.$set(this.orderTypeDownObj, 'top', top )
						
					// this.$set(this.orderTypeDownObj, 'top', event.clientY - this.orderTypeDownObj.clientY - (2.5 * this.remRatio)/2 )
				} else{
					// console.log(obj,index,this.orderTypeDownObj.clientY+this.orderTypeDownObj.height)
					let top = event.clientY - this.orderTypeDownObj.clientY - (2.5 * this.remRatio)/2 + this.orderTypeDownObj.scrollTop;
					if(top > this.orderTypeDownObj.height - 2.5 * this.remRatio  + this.orderTypeDownObj.scrollTop){
						top = this.orderTypeDownObj.height - 2.5 * this.remRatio + this.orderTypeDownObj.scrollTop
					}
					if(top < 0){
						top = 0;
					}
					this.orderTypeDownObj.moveIndex = Math.floor(top/(2.5 * this.remRatio)+0.5)
					// console.log(top,2.5 * this.remRatio,Math.floor(top/(2.5 * this.remRatio)))
					console.log(this.orderTypeDownObj.moveIndex,this.orderTypeDownObj.index)

					this.$set(this.orderTypeDownObj, 'top', top )
						
					// this.$set(this.orderTypeDownObj, 'top', event.clientY - this.orderTypeDownObj.clientY - (2.5 * this.remRatio)/2 )
				}
			}
		},
		orderMouseup(obj){
			console.log('up',this.isMobile,this.orderTypeDownObj.moveIndex,this.orderTypeDownObj.index,this.orderTypeDownObj.drag)
			if(this.orderTypeDownObj.drag){
				// let orderList = [];
				let orderNameArr = []
				obj.orderList.splice(this.orderTypeDownObj.idx, 1);
				obj.orderList.splice(this.orderTypeDownObj.moveIndex, 0 ,{
					name:this.orderTypeDownObj.name,
					id:this.orderTypeDownObj.id
				});
				for(let d of obj.orderList){
					orderNameArr.push(d.name)
				}
				obj.orderName = orderNameArr.join(',')
				// console.log(event,obj,index)
				this.$set(this.orderTypeDownObj, 'drag', false);
				this.$set(this.orderTypeDownObj, 'id', '');
				this.$set(this.orderTypeDownObj, 'index', 0);
				this.$set(this.orderTypeDownObj, 'name', '');
				this.$set(this.orderTypeDownObj, 'top', 0);
				this.$set(this.orderTypeDownObj, 'moveIndex', 0);
				this.$set(this.orderTypeDownObj, 'idx', 0);
				this.$set(this.orderTypeDownObj, 'scrollTop', 0);
			} 
		},
		orderMousedown(event,obj,index,item,idx){
			console.log('down',this.isMobile,this.orderTypeDownObj.moveIndex,this.orderTypeDownObj.index,this.orderTypeDownObj.drag)
			if(this.isMobile){
				event.preventDefault();
				event = event.touches[0];

				// var touch = event.targetTouches[0];
				// startPos = {x:touch.pageX,y:touch.pageY,time:+new Date}; 
				// isScrolling = 0; //这个参数判断是垂直滚动还是水平滚动
				// this.slider.addEventListener('touchmove',this,false);
				// this.slider.addEventListener('touchend',this,false);
				
				this.orderTypeDownObj.index = index;
				this.orderTypeDownObj.idx = idx;
				this.orderTypeDownObj.name = item.name;
				this.orderTypeDownObj.id = item.id;
				let top = event.clientY - this.orderTypeDownObj.clientY - (2.5 * this.remRatio)/2 + this.orderTypeDownObj.scrollTop;
				this.$set(this.orderTypeDownObj, 'drag', true);
				this.$set(this.orderTypeDownObj, 'top', top );
				this.$set(this.orderTypeDownObj, 'moveIndex', Math.floor(top/(2.5 * this.remRatio)+0.5 ));
				console.log(event,obj,index,'---6-')
			} else{
				this.orderTypeDownObj.index = index;
				this.orderTypeDownObj.idx = idx;
				this.orderTypeDownObj.name = item.name;
				this.orderTypeDownObj.id = item.id;
				let top = event.clientY - this.orderTypeDownObj.clientY - (2.5 * this.remRatio)/2 + this.orderTypeDownObj.scrollTop;
				this.$set(this.orderTypeDownObj, 'drag', true);
				this.$set(this.orderTypeDownObj, 'top', top );
				this.$set(this.orderTypeDownObj, 'moveIndex', Math.floor(top/(2.5 * this.remRatio)+0.5 ));
				console.log(event,obj,index,'----')
			}
		},
		orderScroll(event){
			this.orderTypeDownObj.scrollTop = event.target.scrollTop;
			// console.log(event.target.scrollTop)
		},
		deviceSelectFun(index) {
			if (this.deviceList.length > 0) {
				if (this.deviceSelectShowArr[index]) {
					this.$set(this.deviceSelectShowArr, index, false)
				} else {
					this.$set(this.deviceSelectShowArr, index, true)
				}
			}
			console.log(this.deviceList, '--1-2-11')
		},
		subSceneAdd() {
			this.$set(this.sceneForm.subSceneList, this.sceneForm.subSceneList.length,
				{
					groupNames: '',
					groupIds: '',
					deviceIds: '',
					deviceNames: '',
					groupIdsArr: [],
					lampIdArr: [],
					type: 1,
					typeName: this.$t('App.sceneSetting.sceneType1'),
					value: 0,
					color: 0,
				}
			)

			this.scenePaging = Math.ceil(this.sceneForm.subSceneList.length) - 1;
			this.sceneTotal = Math.ceil(this.sceneForm.subSceneList.length) - 1;
			// console.log(this.sceneTotal)
			// this.subSceneList = this.sceneForm.subSceneList.slice(this.scenePaging*2,this.scenePaging*2+2);
			// console.log(this.subSceneList,this.sceneForm.subSceneList,this.scenePaging*2,this.scenePaging*2+2)
		},
		subSceneDel(index,obj) {
			this.sceneForm.subSceneList.splice(index, 1)
			this.scenePaging = index - 1;
			this.sceneTotal = Math.ceil(this.sceneForm.subSceneList.length) - 1;
			this.orderInit(obj,'group')
			
			this.groupIdsArrAll = [];
			for (let d of this.sceneForm.subSceneList) {
				this.groupIdsArrAll = this.groupIdsArrAll.concat(d.groupIdsArr)
			}
		},
		saveSceneFun() {
			if (!this.sceneId) {
				this.sceneAdd();
				console.log('--111')
			} else {
				this.sceneEdit();
				console.log('--5522')
			}
		},
		sceneAdd() {
			if (this.loading.sceneAdd) {
				return
			}
			this.loading.sceneAdd = true;
			let subSceneList = [];
			for (let d of this.sceneForm.subSceneList) {
				
				// subSceneList.push({
				// 	type: d.type,
				// 	value: d.value,
				// 	duration: d.duration,
				// 	groupIds: d.groupIdsArr.join(','),
				// 	deviceIds: d.lampIdArr.join(','),
				// })
				let orderList = []
				for(let key in d.orderList){
					orderList.push({
						deviceId: d.orderList[key].id,
						orderId: key
					})
				}
				// console.log(orderList)
				subSceneList.push({
					type: d.type,
					value: d.value,
					color: d.color,
					duration: d.duration,
					groupIds: d.groupIdsArr.join(','),
					deviceIds: d.lampIdArr.join(','),
					orderList: d.type ==2?JSON.stringify( orderList):''
				})
			}
			// console.log(subSceneList,val)
			base.ajax_post(
				allUrl.scene.scene_add,
				{
					username: this.username,
					version: this.version,
					token: this.token,
					projectId: this.projectId,
					name: this.sceneForm.name,
					// subSceneMap: JSON.stringify(subSceneList),
					subSceneMap: subSceneList,
				},
				{},
				data => {
					
					if(this.getUserSettingInfoDate.sceneStatus == 0){
						this.confirmSelection()
					}else{
						this.$emit('pageTypeFun', 'sceneSetting')
					}
					this.$store.commit('projectUpdateFun', {
						projectUpdate: this.projectUpdate+1,
					})
					
					this.$message({
						showClose: true,
						message: data.msg,
						type: 'success'
					});
					this.loading.sceneAdd = false;
					// console.log(this.getUserSettingInfoDate.sceneStatus, '--1011---')
					
					// this.$emit('pageTypeFun',val)
					// this.projectNavList()
				},
				this, () => {
					this.loading.sceneAdd = false;
				}
			)
		},
		sceneEdit() {
			this.subSceneList = this.sceneForm.subSceneList
			// console.log(this.subSceneList, '--999-444')
			let subSceneList = [];
			for (let d of this.sceneForm.subSceneList) {
				let orderList = []
				for(let key in d.orderList){
					orderList.push({
						deviceId: d.orderList[key].id,
						orderId: key
					})
				}
				// console.log(orderList)
				subSceneList.push({
					type: d.type,
					value: d.value,
					color: d.color,
					duration: d.duration,
					groupIds: d.groupIdsArr.join(','),
					deviceIds: d.lampIdArr.join(','),
					orderList: d.type ==2?JSON.stringify( orderList):''
				})
			}
			// console.log(subSceneList)
			base.ajax_post(
				allUrl.scene.scene_update,
				{
					username: this.username,
					version: this.version,
					token: this.token,
					id: this.sceneId,
					name: this.sceneForm.name,
					subSceneMap: subSceneList,
				},
				{},
				data => {
					this.$message({
						showClose: true,
						message: data.msg,
						type: 'success'
					});
					this.$emit('pageTypeFun', 'sceneSetting')
					// this.loading.sceneAdd = false;
					// console.log(this.lampList)
				},
				this
			)
		},
		groupNavGet(callback) {
			base.ajax_post(
				allUrl.group.group_nav,
				{
					username: this.username,
					version: this.version,
					token: this.token,
					projectId: this.projectId
				},
				{},
				data => {
					callback(data)
				},
				this
			)
		},
		sceneDetailsGet() {
			base.ajax_post(
				allUrl.scene.scene_details,
				{
					username: this.username,
					version: this.version,
					token: this.token,
					id: this.sceneId
				},
				{},
				data => {
					this.sceneForm.name = data.data.name;
					this.sceneForm.subSceneList = data.data.subSceneList;

					this.scenePaging = Math.ceil(this.sceneForm.subSceneList.length) - 1;
					this.sceneTotal = Math.ceil(this.sceneForm.subSceneList.length) - 1;

					this.lampIdArrAll = [];
					this.groupIdsArrAll = [];

					this.groupNavGet(obj => {
						// this.sceneForm.subSceneList.id = id
						console.log(this.sceneForm.subSceneList, '-44-1-11')
						for (let dd of obj.data) {
							dd.select = 0;
							if (dd.type == 1) {
								this.groupList.push(dd)
							} else {
								this.deviceList.push(dd)
							}
						}

						for (let d of this.sceneForm.subSceneList) {
							this.$set(d, 'lampNames', '');
							this.$set(d, 'lampIdArr', d.deviceIds?d.deviceIds.split(',') : []);
							this.lampIdArrAll = this.lampIdArrAll.concat(d.groupIdsArr)
							
							for (let id of d.deviceIds.split(',')) {
								for (let dd of obj.data) {
									dd.select = 0;
									if (dd.type != 1) {
										if (dd.id == id) {
											if (d.lampNames == '') {
												d.lampNames = dd.name
											} else {
												d.lampNames += ',' + dd.name;
											}
										}
									}
								}
							}
							this.$set(d, 'groupNames', '');
							this.$set(d, 'groupIdsArr', d.groupIds ? d.groupIds.split(',') : []);
							this.groupIdsArrAll = this.groupIdsArrAll.concat(d.groupIdsArr)
							for (let id of d.groupIds.split(',')) {
								for (let dd of obj.data) {
									dd.select = 0;
									if (dd.type == 1) {
										if (dd.id == id) {
											if (d.groupNames == '') {
												d.groupNames = dd.name
											} else {
												d.groupNames += ',' + dd.name;
											}
										}
									}
								}
							}
							// console.log(d, this.sceneTypeArr, '---')

							for (let dd of this.sceneTypeArr) {
								if (d.type == dd.id) {
									d.typeName = dd.name
									d.type = dd.id
								}
							}
							if(d.type == 2){
								this.orderInit(d)
								// let orderList = [];
								// let orderNameArr = [];
								// // console.log(d,'-s-s-s-s---')
								// for(let dd of d.orderList){
								// 	orderList.push({id:dd.deviceId,name:dd.deviceName})
								// 	orderNameArr.push(dd.deviceName)
								// }
								// this.$set(d,'orderList',orderList);
								// this.$set(d,'orderName',orderNameArr.join(','));
							}else{
								this.$set(d,'orderList',[]);
								this.$set(d,'orderName','');
							}
						}
						
						// this.$set(obj,'orderList',[]);
						// this.$set(obj,'orderName','');
						// orderNameArr.push(d.name)
						// obj.orderList.push({name:d.name,id:d.id})
						// this.orderInit(obj)

					});
					console.log(this.sceneForm)
				},
				this
			)
		},
		colorStyle(obj){
			let data = {'--color':obj.color?this.kelvinToRGBA(obj.color):'#00c6ff'}
			return data
		},
		kelvinToRGBA(kelvin, alpha = 1) {
			// 规范化输入范围
			kelvin = Math.max(2700, Math.min(6500, kelvin));
			
			// 关键色温采样点(基于CIE 1931色彩空间)
			const colorPoints = [
				{ temp: 2700, r: 256, g: 247, b: 126 },
				{ temp: 3045, r: 254, g: 248, b: 144 },
				{ temp: 3390, r: 254, g: 248, b: 155 },
				{ temp: 3735, r: 254, g: 249, b: 176 },
				{ temp: 4080, r: 254, g: 250, b: 196 },
				{ temp: 4425, r: 254, g: 251, b: 225 },
				{ temp: 4772, r: 245, g: 253, b: 245 },
				{ temp: 5120, r: 255, g: 255, b: 255 },
				{ temp: 5465, r: 247, g: 250, b: 255 },
				{ temp: 5810, r: 237, g: 249, b: 255 },
				{ temp: 6155, r: 228, g: 248, b: 255 },
				{ temp: 6500, r: 202, g: 2544, b: 254 }
			];

			// 三次样条插值计算
			const interpolate = (x, x0, x1, y0, y1) => {
				const t = (x - x0) / (x1 - x0);
				return y0 + t * (y1 - y0);
			};

			// 查找最近的色温区间
			let lower, upper;
			for (let i = 0; i < colorPoints.length - 1; i++) {
				if (kelvin >= colorPoints[i].temp && kelvin <= colorPoints[i+1].temp) {
					lower = colorPoints[i];
					upper = colorPoints[i+1];
					break;
				}
			}

			// 计算RGB分量
			const r = Math.round(interpolate(kelvin, lower.temp, upper.temp, lower.r, upper.r));
			const g = Math.round(interpolate(kelvin, lower.temp, upper.temp, lower.g, upper.g));
			const b = Math.round(interpolate(kelvin, lower.temp, upper.temp, lower.b, upper.b));

			return `rgba(${r}, ${g}, ${b}, ${alpha})`;
		},
	},
	watch: {
		// projectId: function () {
		//   this.groupNavGet();
		// },
		// updateRemRatio:function(){
		// }
	}
}
</script>

<style type="text/css" lang="less">
.sceneSettingEdit_main {
	// opacity: 0.85;
	position: absolute;
	top: 5.78rem;
	left: 0;
	width: 100%;
	height: calc(100% - 5.78rem);
	min-height: 50rem;
	margin: 0 auto;
	overflow: hidden;
	// position: relative;
	// display: flex;
	// background: rgba(255, 255, 255, 0.85);
	background-image: url("../img/login/background_1.png");
	background-position: center;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	&.ja{
		.foot_box{
			.btn1{
				width: initial;
				padding: 0 0.5rem;
			}
		}
	}
	// padding: 15.63rem 0 0 16.23rem;
	.cont_box {
		height: calc(100% - 6.25rem);
		// display: flex;
		// align-items: center;
		// justify-content: center;
		padding-top: 6.25rem;
		padding-left: 19rem;
	}

	.foot_box {
		// margin-top: 5.07rem;
		display: flex;
		align-items: center;
		position: relative;

		.paging_box {
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;

			.paging {
				margin: 0 5rem;
				font-family: Calibri;
				font-weight: normal;
				font-size: 1.8rem;
				color: #3A636F;
			}

			.icon {
				width: 2.2rem;
				height: 2.2rem;
				cursor: pointer;
				user-select: none;

				&.icon1 {
					background-image: url('../img/icon/paging.png');
					transform: rotateZ(180deg);
				}

				&.icon2 {
					background-image: url('../img/icon/paging.png');
				}
			}
		}

		.btn1 {
			position: absolute;
			top: 0;
			left: 97rem;
			width: 8.3rem;
			height: 3.5rem;
			line-height: 3.5rem;
			background: #F4FBFD;
			border: 0.09rem solid #3A636F;
			border-radius: 0.26rem;
			text-align: center;

			font-size: 1.8rem;
			font-family: Calibri;
			font-weight: normal;
			color: #3A636F;
			cursor: pointer;
			user-select: none;
			margin-right: 19rem;
		}

		.btn2 {
			position: absolute;
			top: 0;
			left: 110rem;
			width: 8.3rem;
			height: 3.5rem;
			line-height: 3.5rem;
			background: #00C6FF;
			border: 0.09rem solid #00C6FF;
			border-radius: 0.26rem;
			text-align: center;

			font-size: 1.8rem;
			font-family: Calibri;
			font-weight: normal;
			color: #FFFFFF;
			cursor: pointer;
			user-select: none;
		}
	}

	.addBtn {
		position: absolute;
		left: 20rem;
		bottom: 10rem;
		width: 3.42rem;
		height: 3.42rem;
		background-image: url('../img/icon/btn_bg1.png');
		cursor: pointer;
	}

	.form_box {
		// margin-top: 2.89rem;
		height: calc(100% - 7.25rem);

		.flex_box {
			display: flex;
			height: 18rem;
			margin-top: 2rem;
			.delBtn {
				text-align: center;
				min-width: 5.5rem;
				padding: 0 1rem;
				height: 3.13rem;
				line-height: 3.13rem;
				background: #F4FBFD;
				border-radius: 0.2rem;
				border: 0.1rem solid #3A636F;

				font-family: Calibri;
				font-weight: normal;
				font-size: 1.8rem;
				color: #3A636F;
				cursor: pointer;
			}
		}

		.form_item {

			// display: flex;
			// align-items: center;
			&:nth-child(1) {
				margin-bottom: 0.5rem;
			}

			&.margin {
				margin-left: 15rem;
				.select_lm{
					.val_box {
						height: 3rem;
						.val {
							line-height: 3rem;
						}
						.icon_x {
							top: 0.8rem;
						}
					}
				}
			}

			.label {
				font-size: 1.8rem;
				font-family: Calibri;
				font-weight: normal;
				color: rgba(58, 99, 111, 1);
				margin-bottom: 2rem;
				.i {
					margin-right: 0.5rem;
					color: #FF0101;
				}

				.select_lm {
					.select_xl_lm {
						width: 19rem;
					}
				}
			}

			.text_box {
				margin-top: 2rem;
				width: 6.5rem;
				height: 3rem;
				line-height: 3rem;
				border-radius: 0.33rem;
				border: 0.1rem solid #3A636F;
				text-align: center;
				font-family: Calibri;
				font-weight: normal;
				font-size: 1.8rem;
				color: #3A636F;
			}

			.form_item_content {

				margin-top: 2rem;
				.slider_box{
					margin-bottom: 3rem;
				}
				.label {
					text-align: left;
					font-family: Calibri;
					font-weight: normal;
					font-size: 1.8rem;
					color: #3A636F;
					width: 12rem;
					padding-left: 1rem;
				}

				.select_lm {
					width: 19rem;
					.val_box {
						height: 3rem;
						.val {
							line-height: 3rem;
						}
						.icon_x {
							top: 0.8rem;
						}
					}
				}
				.el-input-number{
					width: calc(100% - 10.5rem);
				}
				.el-input__inner {
					margin-left: 0.5rem;
					padding-left: 0rem;
					width: 100%;
					height: 2.17rem;
					line-height: 2.17rem;
					border: none;
					border: 0.1rem solid #3a636f;
					border-radius: 0.5rem;
					background-color: #f4fbfd;

					font-size: 1.8rem;
					font-family: Calibri;
					font-weight: normal;
					color: #3A636F;
				}

			}

			.input1 {
				.el-input__inner {
					padding-left: 0rem;
					width: 30rem;
					height: 3rem;
					line-height: 3rem;
					border: none;
					border-bottom: 0.1rem solid #3A636F;
					border-radius: 0;
					background-color: rgba(0, 0, 0, 0);

					font-size: 1.8rem;
					font-family: Calibri;
					font-weight: normal;
					color: #3A636F;
				}

				.el-input__prefix {
					width: 1.8rem;
					height: 1.8rem;
					top: 0.96rem;
					left: 0.79rem;

					.icon {
						width: 100%;
					}
				}

				.el-input__suffix {
					height: 4.12rem;
					line-height: 4.12rem;
					right: 1.49rem;
				}
			}

			.span {
				margin-top: -0.2rem;
				font-size: 1.8rem;
				font-family: Calibri;
				font-weight: normal;
				color: #3A636F;
				position: relative;
				top: -0.2rem;
			}

			.el-input .el-select__caret {
				font-size: 1.8rem;
				color: rgba(58, 99, 111, 1);
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}

	.project_completed {
		position: fixed;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;

		.bg {
			position: absolute;
			width: 100%;
			height: 100%;
			background: rgba(0, 0, 0, 0);
			z-index: -1;
			opacity: 0.5;
		}

		.form_box {
			position: relative;
			width: 36.51rem;
			height: 18.09rem;
			padding-top: 2.83rem;
			background: #FFFFFF;
			border: 0px solid #3A636F;
			border-radius: 0.2rem;
			opacity: 0.9;

			.span {
				font-family: Calibri;
				color: #3A636F;
				text-align: center;
				width: 23.22rem;
				font-weight: 400;
				font-size: 1.8rem;
				color: #4C717C;
				margin: auto;
			}

			.btn_box0 {
				// position: absolute;
				// bottom: 0rem;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: 5.07rem;
				// margin: 4.47rem auto 0;
				// width: 26.69rem;

				.btn2 {
					width: 6.25rem;
					height: 2.63rem;
					background: #00C6FF;
					border-radius: 0.2rem;

					line-height: 2.63rem;
					border: 0.09rem solid #00C6FF;
					text-align: center;
					// font-family: Calibri;
					// font-weight: normal;
					// color: #FFFFFF;
					cursor: pointer;
					user-select: none;

					font-family: Calibri;
					font-weight: 400;
					font-size: 1.8rem;
					color: #FFFFFF;
				}
			}
		}
	}
}

.select_lm {
	.val_box {
		// background: #F4FBFD;
		height: 3rem;
		background: rgba(244, 251, 253, 1)
	}

	.select_xl_lm {
		width: 18.55rem;
		&.drag{
			user-select: none;
			.ul{
				position: relative;
			}
			.li{
				&.select{
					position: absolute;
					left: 0;right: 0;
				}
			}
		}
	}
}
// .sceneSettingEdit_main.themeType_1 {
// 	background-image: none;
// 	background: rgba(250,  237, 218, 0.85);
// 	.select_lm {
		
// 		.val_box {
// 			// background: #F4FBFD;
// 			background: rgba(244, 251, 253, 1);
// 			.icon_x {
// 				width: 1rem;
// 				background-image: url("../img/orange/rightArrow.png");
// 			}
// 		}
// 		.select_xl_lm {
// 			.ul {
// 				background: #faedda;
// 			}
// 		}
// 	}
// 	.select_lm.multiple .selectDrop {
// 		border: 0.13rem solid #e09259;
// 		.drop {
// 			background: #e09259;
// 		}
// 	}
// 	.foot_box {
// 		.paging_box {
// 			.paging {
// 				color: #682411;
// 			}
// 			.icon {
// 				&.icon1 {
// 					background-image: url('../img/icon/paging.png');
// 					transform: rotateZ(180deg);
// 				}

// 				&.icon2 {
// 					background-image: url('../img/icon/paging.png');
// 				}
// 			}
// 		}
// 		.btn1 {
// 			background: #f2cd9b;
// 			border: 0.09rem solid #682411;
// 			color: #682411;
// 		}
// 		.btn2 {
// 			background: #f44336;
// 			border: 0.09rem solid #f44336;
// 			color: #ffffff;
// 		}
// 	}
// 	.addBtn {
// 		background-image: url(../img/orange/btn_bg1.png);
// 	}
// 	.form_box {
// 		.flex_box {
// 			.delBtn {
// 				background: #f2cd9b;
// 				border: 0.1rem solid #682411;
// 				color: #682411;
// 			}
// 		}
// 		.form_item {
// 			.label {
// 				color: #682411;
// 			}
// 			.text_box {
// 				border: 0.1rem solid #682411;
// 				color: #682411;
// 			}

// 			.form_item_content {
// 				.label {
// 					color: #682411;
// 				}
// 				.el-input__inner {
// 					background-color: #f4fbfd;
// 					border: 0.1rem solid #682411;
// 					// background-color: rgba(0, 0, 0, 0);
// 					color: #682411;
// 				}

// 			}
// 			.input1 {
// 				.el-input__inner {
// 					border-bottom: 0.1rem solid #682411;
// 					background-color: rgba(0, 0, 0, 0);
// 					color: #682411;
// 				}
// 			}
// 			.span {
// 				color: #682411;
// 			}

// 			.el-input .el-select__caret {
// 				color: #682411;
// 			}
// 		}
// 	}
// 	.slider_box .el-silder_runway {
// 		background: #fdbe6e;
// 	}
// 	.el-tooltip__popper.is-dark{
// 		color: #682411;
// 	}
// }
</style>